import React from "react";

import "./SideDrawer.css";

import Logo from "../../assets/image/AtlasLogoTransparentSide2.png";
import Location from "../../assets/Icons/map.svg";
import Phone from "../../assets/Icons/phone.svg";
import Time from "../../assets/Icons/time.svg";
import Message from "../../assets/Icons/message.svg";
import X from "../../assets/Icons/X.png";

import { Link, NavLink, useLocation } from "react-router-dom";

const SideDrawer = (props) => {
	const location = useLocation();
	let drawerClasses = "side-drawer";

	if (props.show) {
		drawerClasses = "side-drawer open";
	}

	const isActive = (pathname, state = {}) => {
		return (
			location.pathname === pathname &&
			(!state.lang ||
				(location.state && location.state.lang === state.lang))
		);
	};

	return (
		<nav className={drawerClasses}>
			<div className="SideDrawerTop">
				<Link to="/" onClick={props.click}>
					<img className="sideDrawerLogo" src={Logo} alt="Atlas" />
				</Link>
				<button
					className="sideDrawerCloser"
					onClick={props.click}
					aria-label="Loka valmynd"
				>
					<img src={X} alt="" />
				</button>
			</div>

			<ul className="SideDrawerNav">
				<li className="SideDrawerCategory">
					<NavLink
						end
						to="/sjukrathjalfun"
						state={{ lang: "icelandic" }}
						onClick={props.click}
						className={
							isActive("/sjukrathjalfun", { lang: "icelandic" })
								? "activeTab"
								: ""
						}
					>
						Sjúkraþjálfun
					</NavLink>
				</li>
				<li className="SideDrawerSubCategory">
					<NavLink
						end
						to="/sjukrathjalfun/gjaldskra"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Gjaldskrá
					</NavLink>
				</li>

				<li className="SideDrawerCategory">
					<NavLink
						to="/starfsfolk"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Starfsfólk
					</NavLink>
				</li>

				<li className="SideDrawerCategory">
					<NavLink
						end
						to="/umokkur"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Um okkur
					</NavLink>
				</li>
				<li className="SideDrawerSubCategory">
					<NavLink
						end
						to="/umokkur/stadsetning"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Staðsetning
					</NavLink>
				</li>
				<li className="SideDrawerSubCategory">
					<NavLink
						end
						to="/umokkur/personuvernd"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Persónuvernd
					</NavLink>
				</li>

				<li className="SideDrawerCategory">
					<NavLink
						to="/frettir"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Fréttir og greinar
					</NavLink>
				</li>

				<li className="SideDrawerCategory">
					<NavLink
						to="/timabokun"
						onClick={props.click}
						className={({ isActive }) => isActive ? "activeTab" : ""}
					>
						Hafa samband
					</NavLink>
				</li>
			</ul>

			<div className="SideDrawerLang">
				<ul>
					<li>
						<NavLink
							end
							to="/sjukrathjalfun"
							state={{ lang: "english" }}
							onClick={props.click}
							className={
								isActive("/sjukrathjalfun", { lang: "english" })
									? "activeTab"
									: ""
							}
						>
							Physiotherapy - English
						</NavLink>
					</li>
					<li>
						<NavLink
							end
							to="/sjukrathjalfun"
							state={{ lang: "spanish" }}
							onClick={props.click}
							className={
								isActive("/sjukrathjalfun", { lang: "spanish" })
									? "activeTab"
									: ""
							}
						>
							Fisioterapia - Español
						</NavLink>
					</li>
				</ul>
			</div>

			<div className="SideDrawerInfo">
				<ul>
					<li>
						<Link to="/timabokun" onClick={props.click}>
							<img className="sideDrawerIconImg" src={Phone} alt="Sími" />
							<span> 5526600 </span>
						</Link>
					</li>

					<li>
						<Link to="/umokkur/stadsetning" onClick={props.click}>
							<img
								className="sideDrawerIconImg"
								src={Location}
								alt="Staðsetning"
							/>
							<span> Íþróttamiðstöð Laugardal </span>
						</Link>
					</li>

					<li>
						<Link to="/timabokun" onClick={props.click}>
							<img className="sideDrawerIconImg" src={Message} alt="Email" />
							<span> afgreidsla@atlasendurhaefing.is </span>
						</Link>
					</li>

					<li>
						<Link to="/timabokun" onClick={props.click}>
							<img className="sideDrawerIconImg" src={Time} alt="Opnunartími" />
							<span> mán-fim 8:00-16:30 / fös 8:00-16:00 </span>
						</Link>
					</li>
				</ul>
			</div>
		</nav>
	);
};

export default SideDrawer;
